import { useState } from 'react';
import Layout from '../components/Layout';
import client from '../api/client';

export default function PlaceRankCompare() {
  const [myUrl, setMyUrl] = useState('');
  const [compUrl, setCompUrl] = useState('');
  const [keywordsText, setKeywordsText] = useState('');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const s: any = {
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, padding: 20, marginBottom: 16 },
    input: { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 14px', color: '#E8ECF4', fontSize: 13, boxSizing: 'border-box' as const },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 28px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
    label: { color: '#B0BAC8', fontSize: 12, marginBottom: 6, display: 'block' },
  };

  const handleCompare = async () => {
    const keywords = keywordsText.split('\n').map(k => k.trim()).filter(Boolean);
    if (!myUrl || !compUrl) return alert('두 플레이스 URL을 입력하세요');
    if (keywords.length === 0) return alert('키워드를 입력하세요');
    if (keywords.length > 30) return alert('키워드는 최대 30개');
    setLoading(true);
    try {
      const res = await client.post('/place-rank/compare', { my_url: myUrl, comp_url: compUrl, keywords });
      setResult(res.data);
    } catch { alert('비교 실패'); }
    finally { setLoading(false); }
  };

  const winCount = result?.results?.filter((r: any) => !r.error && r.my_better).length || 0;
  const total = result?.results?.filter((r: any) => !r.error).length || 0;

  return (
    <Layout>
      <div style={{ maxWidth: 900 }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ color: '#E8ECF4', fontSize: 18, fontWeight: 700 }}>플레이스 경쟁사 순위 비교</div>
          <div style={{ color: '#8892A4', fontSize: 12, marginTop: 4 }}>키워드별로 내 플레이스와 경쟁사 플레이스 순위를 비교합니다</div>
        </div>

        <div style={s.card}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ ...s.label, color: '#00D4AA' }}>⭐ 내 플레이스 URL</label>
              <input style={s.input} value={myUrl} onChange={e => setMyUrl(e.target.value)} placeholder="https://map.naver.com/p/entry/place/..." />
            </div>
            <div>
              <label style={{ ...s.label }}>경쟁사 플레이스 URL</label>
              <input style={s.input} value={compUrl} onChange={e => setCompUrl(e.target.value)} placeholder="https://map.naver.com/p/entry/place/..." />
            </div>
          </div>
          <label style={s.label}>비교 키워드 (줄바꿈으로 구분, 최대 30개)</label>
          <textarea style={{ ...s.input, height: 160, resize: 'vertical' as const, marginBottom: 16 }}
            value={keywordsText} onChange={e => setKeywordsText(e.target.value)}
            placeholder={"전주카페\n전주 디저트\n전주 휘낭시에\n전주 베이커리"} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button style={s.btn} onClick={handleCompare} disabled={loading}>{loading ? '비교 중...' : '순위 비교 시작'}</button>
            {loading && <div style={{ color: '#8892A4', fontSize: 12 }}>키워드당 약 1초 소요됩니다...</div>}
          </div>
        </div>

        {result && (
          <>
            {/* 요약 */}
            <div style={{ ...s.card, display: 'flex', gap: 20, alignItems: 'center' }}>
              <div style={{ flex: 1, textAlign: 'center' as const }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: '#00D4AA' }}>{winCount}</div>
                <div style={{ color: '#8892A4', fontSize: 12 }}>내가 앞선 키워드</div>
              </div>
              <div style={{ flex: 1, textAlign: 'center' as const }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: '#F56565' }}>{total - winCount}</div>
                <div style={{ color: '#8892A4', fontSize: 12 }}>경쟁사가 앞선 키워드</div>
              </div>
              <div style={{ flex: 1, textAlign: 'center' as const }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: '#E8ECF4' }}>{total}</div>
                <div style={{ color: '#8892A4', fontSize: 12 }}>전체 비교 키워드</div>
              </div>
              <div style={{ flex: 2, background: '#0F1117', borderRadius: 8, padding: '12px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', height: 12, borderRadius: 6, overflow: 'hidden', marginBottom: 6 }}>
                  <div style={{ width: `${total ? (winCount/total*100) : 0}%`, background: '#00D4AA', height: '100%', transition: 'width 0.5s' }} />
                  <div style={{ flex: 1, background: '#F56565', height: '100%' }} />
                </div>
                <div style={{ color: '#8892A4', fontSize: 11 }}>내 플레이스 우위: {total ? Math.round(winCount/total*100) : 0}%</div>
              </div>
            </div>

            {/* 키워드별 결과 */}
            <div style={s.card}>
              <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 700, marginBottom: 16 }}>키워드별 순위 비교</div>
              <table style={{ width: '100%', borderCollapse: 'collapse' as const }}>
                <thead>
                  <tr style={{ background: '#1A2035' }}>
                    <th style={{ padding: '10px 14px', color: '#8892A4', fontSize: 11, textAlign: 'left' as const }}>키워드</th>
                    <th style={{ padding: '10px 14px', color: '#00D4AA', fontSize: 11, textAlign: 'center' as const }}>내 플레이스</th>
                    <th style={{ padding: '10px 14px', color: '#8892A4', fontSize: 11, textAlign: 'center' as const }}>경쟁사</th>
                    <th style={{ padding: '10px 14px', color: '#8892A4', fontSize: 11, textAlign: 'center' as const }}>결과</th>
                  </tr>
                </thead>
                <tbody>
                  {result.results?.map((r: any, i: number) => (
                    <tr key={i} style={{ borderBottom: '0.5px solid #1E2535' }}>
                      <td style={{ padding: '10px 14px', color: '#E8ECF4', fontSize: 13 }}>{r.keyword}</td>
                      {r.error ? (
                        <td colSpan={3} style={{ padding: '10px 14px', color: '#F56565', fontSize: 12 }}>오류: {r.error}</td>
                      ) : (
                        <>
                          <td style={{ padding: '10px 14px', textAlign: 'center' as const }}>
                            <span style={{ color: r.my.rank ? (r.my_better ? '#00D4AA' : '#E8ECF4') : '#F56565', fontSize: 14, fontWeight: 700 }}>
                              {r.my.rank_display}위
                            </span>
                          </td>
                          <td style={{ padding: '10px 14px', textAlign: 'center' as const }}>
                            <span style={{ color: r.comp.rank ? (!r.my_better ? '#F56565' : '#E8ECF4') : '#8892A4', fontSize: 14, fontWeight: 700 }}>
                              {r.comp.rank_display}위
                            </span>
                          </td>
                          <td style={{ padding: '10px 14px', textAlign: 'center' as const }}>
                            {!r.my.rank && !r.comp.rank ? (
                              <span style={{ color: '#8892A4', fontSize: 11 }}>둘 다 30위 밖</span>
                            ) : r.my_better ? (
                              <span style={{ background: '#00D4AA22', border: '1px solid #00D4AA55', borderRadius: 4, padding: '2px 8px', color: '#00D4AA', fontSize: 11 }}>✅ 내가 앞섬</span>
                            ) : (
                              <span style={{ background: '#F5656522', border: '1px solid #F5656555', borderRadius: 4, padding: '2px 8px', color: '#F56565', fontSize: 11 }}>❌ 경쟁사 앞섬</span>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
